<template>
  <ul class="exam exam__list">
    <li
      class="exam__item"
      v-for="(exam, id) in exams"
      :key="`exam-list-${id}`"
    >
      <div class="exam__indicator" />
      <div class="exam__content">
        <div class="exam__content-left">
          <span class="exam_date">{{examDateFormatted(exam)}}</span>
          <span class="exam__name">{{ exam.examName | capitalizeText }}</span>
          <span class="exam__payment-type">{{ paymentType }}</span>
        </div>
        <div class="exam__value">
          <span>{{ exam.price | toCurrency }}</span>
        </div>
      </div>
    </li>

  </ul>
</template>

<script>
export default {
  name: 'PaymentList',
  props: {
    exams: [Array],
    paymentType: String,
  },
  filters: {
    toCurrency(value) {
      return new Intl.NumberFormat('pt-BR',
        { style: 'currency', currency: 'BRL' }
      ).format(value);
    }
  },
  methods: {
    examDateFormatted(exam) {
      return this.$moment(exam.schedulingDate).format('DD/MM - HH:mm');
    }
  }
};
</script>

<style scoped lang="scss">
.exam {
  &__list {
    height: 100%;
    overflow-y: scroll;
    border-radius: 4px;
    flex: 1;
  }

  &__indicator {
    width: 10px;
    margin-right: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    align-content: center;

    &::before {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: #D9D9D9;
    }

    &::after {
      content: '';
      display: inline-block;
      width: 2px;
      height: calc(100% - 11px);
      background-color: #D9D9D9;
    }
  }

  &__content-left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    span {
     font-size: 14px;
     line-height: 16.1px;
     font-weight: 700;
     color: #363636;

     &:nth-child(2) {
       margin-top: 4px;
       width: 80%;
       color: #161616;
       font-size: 16px;
       line-height: 24px;
     }

     &:nth-child(3) {
      font-size: 12px;
      font-weight: 400;
      line-height: 15.96px;
      color: #1C5E30;
     }
    }
  }

  &__content {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    align-content: center;
  }

  &__item {
    padding: 12px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: var(--font-size-2);
  }

  &__name {
    text-align: left;
  }

  &__value {
    text-align: right;
    max-width: 85px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    color: #363636;
  }

  &__payment-type {
    font-size: 12px;
    font-weight: 400;
    line-height: 15.96px;
    color: #1C5E30;
  }
}

</style>
